import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalApiClientService {
  isConnected = ""
  callTimeout = 30000;
  host = "localhost";
  portList = [8182, 8283, 8672];
  currentPort = 0;
  guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
      s4() + '-' + s4() + s4() + s4();
  }
  constructor() {
    window["OnStartScaning"] = function () { };
  }
  $jsonp() {

    var that = {

      send: (src, options) => {
        try {
          var callback_name = options.callbackName || 'callback',
            on_success = options.onSuccess || function () { },
            on_timeout = options.onTimeout || function () { },
            timeout = options.timeout || 30000;

          var timeout_trigger = window.setTimeout(function () {
            // window[callback_name] = function () { };
            // on_timeout();
          }, timeout);

          // window[callback_name] = function (data) {
          //   window.clearTimeout(timeout_trigger);
          //   on_success(data);
          // }

          var script = document.createElement('script');
          script.type = 'text/javascript';
          script.async = true;
          script.src = src;
          script.onerror = () => { options.onError() }

          document.getElementsByTagName('head')[0].appendChild(script);
        }
        catch (ex) {
          options.onError()
        }
    }
    }
    return that;
  }

  InitLocalApiClient(index) {
    var _this = this;
    if (!index) {
      index = 0;
    }
    else if (index > this.portList.length) {
      this.currentPort = -1;
      this.isConnected = "false";
      return;
    }
    

    this.$jsonp().send("http://" + this.host + ":" + _this.portList[index] + "/GetHostInfo.js?version=1.0&callback=OnGetHostInfoComplete&params=null&rand=" + this.guid(), {
      callbackName: "OnGetHostInfoComplete",
      onSuccess: function (json) {
        _this.currentPort = _this.portList[index];
        //console.log('success using port:', _this.portList[index]);
        _this.isConnected = "true";
      },
      onError: function () {
        console.log("err")
      },
      onTimeout: function () {
        //console.log("timeout using port:" + _this.portList[index]);
        _this.InitLocalApiClient(++index);

      },
      timeout: 1000
    });
  }
  ExecuteLocalApi(apiName, version, timeout, paramObj, sucFun,errFun = null) {
    var waitForInit = 0;
    var parameters = "null";

    if (!timeout) {
      timeout = this.callTimeout;
    }

    if (!this.currentPort) {
      waitForInit = (this.portList.length + 1) * 1000;
    }

    if (!version) {
      version = "1.0";
    }

    if (paramObj) {
      parameters = JSON.stringify(paramObj)
    }

    setTimeout(() => {
     var apiNameCallback = apiName.split(".")[0];
      this.$jsonp().send("http://" + this.host + ":" + this.currentPort + "/" + apiName + ".js?version=" + version + "&callback=On" + apiNameCallback + "Complete&params=" + parameters, {
        callbackName: "On" + apiNameCallback + "Complete",
        onSuccess: (json) => {
          return sucFun(json);
         // console.log("On" + apiName + "Result" + " success!", json);
        },
        onError: function () {
          if (errFun != null) {
            return errFun()
          }
          
        },
        onTimeout:  ()=> {
          //console.log("On" + apiName + "Result" + " timeout!");
        },
        timeout: timeout
      });
    }, waitForInit);
  }
 
}
